// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import { useState } from 'react';

// Mock sign-in only -- no real auth yet. Same storage-key-shared-across-pages
// pattern as admin-token.ts's useAdminToken, so signing in once on login.html
// carries over to every other page without re-typing the org each time.
const CURRENT_ORG_STORAGE_KEY = 'ncoda.currentOrg';

// Non-hook read for use inside a useState initializer alongside readUrlParam
// (e.g. `readUrlParam('orgName') ?? readCurrentOrg() ?? 'new-co'`), matching
// the synchronous style locked-identity.ts's readUrlParam already uses.
export function readCurrentOrg(): string | null {
  return window.localStorage.getItem(CURRENT_ORG_STORAGE_KEY);
}

export function useCurrentOrg() {
  const [currentOrg, setCurrentOrgState] = useState<string | null>(readCurrentOrg);

  const setCurrentOrg = (value: string) => {
    setCurrentOrgState(value);
    window.localStorage.setItem(CURRENT_ORG_STORAGE_KEY, value);
  };

  const signOut = () => {
    setCurrentOrgState(null);
    window.localStorage.removeItem(CURRENT_ORG_STORAGE_KEY);
  };

  return { currentOrg, setCurrentOrg, signOut };
}
